import Alert from 'antd/lib/alert';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import ReconciliationOutlined from '@ant-design/icons/lib/icons/ReconciliationOutlined';
import WarningOutlined from '@ant-design/icons/lib/icons/WarningOutlined';
import { SECONDARY_COLOR } from 'src/theme';
import { ICustomerUtilityBill } from 'src/domain/customer-utility-bill/interface';
import { BillExtractionStatusAlert } from './BillExtractionStatusAlert';
import { BillSectionHeader } from './BillSectionHeader';
import { BillFormField, FieldError, IBillSectionProps } from './BillFormField';

interface Props extends IBillSectionProps {
    row: ICustomerUtilityBill;
}

// Billing values (kW / kWh / billing period), plus the bill's extraction status / processing error.
export const BillValuesSection = ({ row, ...props }: Props) => (
    <div className="customer-bill-section-source" style={{ marginBottom: 14 }}>
        <BillSectionHeader
            icon={<ReconciliationOutlined style={{ color: SECONDARY_COLOR }} />}
            title="Billing Values"
            fields={['billingKw', 'billingKwh', 'billingPeriodStart', 'billingPeriodEnd']}
            editableFields={props.editableFields}
        />
        <BillExtractionStatusAlert status={row.processingStatus} />
        {row.processingError && <Alert type="error" showIcon icon={<WarningOutlined />} message={row.processingError} style={{ marginBottom: 10 }} />}
        <Row gutter={[20, 10]}>
            <BillFormField {...props} label="BILLING kW" field="billingKw" type="number" />
            <BillFormField {...props} label="BILLING kWh" field="billingKwh" type="number" />
            <BillFormField {...props} label="PERIOD START" field="billingPeriodStart" type="date" invalid={!!props.errors.billingPeriod} />
            <BillFormField {...props} label="PERIOD END" field="billingPeriodEnd" type="date" invalid={!!props.errors.billingPeriod} />
            {props.errors.billingPeriod && (
                <Col span={24}>
                    <FieldError message={props.errors.billingPeriod} />
                </Col>
            )}
        </Row>
    </div>
);
